module.exports = __webpack_public_path__ + "static/media/logo_background.07a2d886.svg";